import { render, staticRenderFns } from "./LMModule.vue?vue&type=template&id=c3be1f3c&"
import script from "./LMModule.vue?vue&type=script&lang=ts&"
export * from "./LMModule.vue?vue&type=script&lang=ts&"
import style0 from "./LMModule.vue?vue&type=style&index=0&id=c3be1f3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports